<div class="modify-res-header popupHeader">
  <span> {{ data?.heading || rGuestBookMessages?.commonConstants?.confirmationHeading }} </span>
</div>
<div class="pad-25">
  <div class="pad-rbl">
    <div mat-dialog-content class="msg-size">
      <div>{{ data?.customMessage || rGuestBookMessages?.commonConstants?.confirmationToProceed }}</div>
    </div>
  </div>
  <div mat-dialog-actions style="justify-content: center">
    <button mat-raised-button color="primary" (click)="onYes(data?.returnSuccessMsg || 'confirm')">
      {{ data?.successButton || rGuestBookMessages?.commonConstants?.proceedButton }}
    </button>
    <button mat-raised-button color="warn" (click)="onNo(data?.returnCloseMsg || false)">
      {{ data?.closeButton || rGuestBookMessages?.commonConstants?.closeButton }}
    </button>
  </div>
</div>
